module.exports = __webpack_public_path__ + "static/media/GoogleKickstart2020.d62fd917.jpeg";